import React from "react";
import { TProbateLeadForm } from "../../../../../../domain/codecs/form/ProbateLeadForm";
import { FPMarketingHelplineCTAInput } from "./FPMarketingHelplineCTAInput";
import { FPMarketingHelplineCTASuccess } from "./FPMarketingHelplineCTASuccess";

export const FPMarketingHelplineCTA = (props: React.PropsWithChildren<{
    coloursInverted?: boolean,
    form: TProbateLeadForm,
    name: string;
    disclaimer?: string,
    autoFocus?: boolean,
    alignDisclaimer?: "left" | "center" | "right";
    onChange: (form: TProbateLeadForm) => void,
    onSubmit: (form: TProbateLeadForm) => void,
}>): JSX.Element => {
    const isSubmitting = props.form.status === "submitting";

    const isSuccess = props.form.status === "success";

    const isShowingInput = !isSuccess;

    return <>
        {/* SHOWING INPUT */}
        {isShowingInput &&
            <FPMarketingHelplineCTAInput
                coloursInverted={props.coloursInverted}
                form={props.form}
                autoFocus={props.autoFocus}
                isSubmitting={isSubmitting}
                disclaimer={props.disclaimer}
                alignDisclaimer={props.alignDisclaimer}
                onChange={props.onChange}
                onSubmit={() => props.onSubmit({
                    ...props.form,
                    edited: {
                        ...props.form.edited,
                        cta: props.name
                    }
                })}
            />
        }

        {/* SHOWING SUCCESS */}
        {isSuccess &&
            <FPMarketingHelplineCTASuccess
                coloursInverted={props.coloursInverted}
            />
        }
    </>;
};
